export const isAuthenticated = (state) => {
    console.log(state, "state is here");
    if (state.auth.auth.tokens?.token || state.auth?.auth?.token || state?.auth?.auth?.data?.token) return true;
    return false;
};
